import { useEffect, useState } from 'react';
import { IMachine } from '../interfaces/IMachine';
import { Spinner } from '../components/Spinner';
import { Machine } from '../components/Machine';
import { AreYouSure } from '../helpers/AlertHelper';
import { DeleteMachine, GetMachines } from '../ApiClient';

export const MachinesPage = () => {
    const [machines, setMachines] = useState<IMachine[] | null>();

    const fetchMachines = () => {
        setMachines(null);
        GetMachines().then(setMachines);
    }

    useEffect(() => {
        fetchMachines();
    }, []);

    const handleDeleteClick = async (machine: IMachine) => {
        if (await AreYouSure(`Are you sure you wish to delete the machine '${machine.name}'?`)) {
            await DeleteMachine(machine.id);
            fetchMachines();
        }
    }

    return (
        <>
            <h3>Machines{machines && ` (${machines.length})`}</h3>
            {!machines && <Spinner />}
            {machines?.map(x => 
                <Machine 
                    key={x.id}
                    machine={x}
                    onDeleteClick={handleDeleteClick} />)}
        </>
    );
}
